import { v4 as uuidv4 } from 'uuid';

const appleSignInConfig = {
  clientId: process.env.APPLE_SIGN_IN_CLIENT_ID,
  redirectURI: process.env.APPLE_SIGN_IN_REDIRECT_URI,
  usePopup: true,
  state: uuidv4(),
  scope: 'name email'
};

export default appleSignInConfig;
